import { ContentLayout } from 'Molecules/ContentLayout/ContentLayout.tsx';
import { FinancialsTablesPageHeader } from './Header/FinancialsTablesPageHeader.tsx';
import { VStack } from '@chakra-ui/react';
import { FilteredFinancials } from './Tables/FilteredFinancials.tsx';
import { BAssessment, ReportingGroup } from 'models/types.ts';
import { BusinessUnitsSortingType } from 'containers/Assessments/pieces/Assessment.hooks.ts';

type FinancialsTablesPageProps = {
  reportingGroups: ReportingGroup[];
  bAssessments: BAssessment[];
  businessUnitsSorting: BusinessUnitsSortingType;
};
export const FinancialsTablesPage = ({
  reportingGroups,
  bAssessments,
  businessUnitsSorting,
}: FinancialsTablesPageProps) => {
  return (
    <ContentLayout variant="inline" header={null} noHeader>
      <VStack width="100%" justifyContent="flex-start" paddingY="0px" pr="16px">
        <FinancialsTablesPageHeader />
        <FilteredFinancials
          reportingGroups={reportingGroups}
          bAssessments={bAssessments ?? []}
          businessUnitsSorting={businessUnitsSorting}
        />
      </VStack>
    </ContentLayout>
  );
};
